import { Card, CardBody, Col, Row } from "reactstrap";
import { Btn, H4, H5, H6 } from "../../../../AbstractElements";
import { Href, Purchase, SimplePricingTitle } from "../../../../Constants/Constants";
import { SimplePricingData } from "../../../../Data/Applications/ECommerce/ECommerce";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SimplePricingCard = () => {
  return (
    <Card>
      <CommonCardHeader title={SimplePricingTitle} />
      <CardBody className="pricing-content">
        <Row className="g-sm-4 g-3">
          {SimplePricingData.map((item, index) => (
            <Col xl="3" sm="6" className="xl-50 box-col-6" key={index}>
              <Card className="text-center pricing-simple">
                <CardBody>
                  <H4>{item.title}</H4>
                  <H5>${item.price}</H5>
                  <H6 className="mb-0">{item.plan}</H6>
                </CardBody>
                <div>
                  <Btn tag="a" color="primary" size="lg" className="btn-block" href={Href}>
                    {Purchase}
                  </Btn>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};

export default SimplePricingCard;
